/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'options': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<path pid="0" d="M13 .5h-2v2H0v2h11v1h2v-5zM15 2.5h5v2h-5v-2zM4 11.5v-1H0v-2h4v-2h2v5H4zM18 14.5H0v2h18v1h2v-5h-2v2zM20 8.5H8v2h12v-2z" _fill="#fff"/>'
  }
})
